<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
        <v-col cols="12">
             <left-emp-menu></left-emp-menu>
        </v-col>
          <v-col>
            <v-row >
            <v-col cols="12">
                  <v-list three-line subheader>
                    <!-- ADD -->
                    <v-dialog v-model="dialogAdd" persistent max-width="80%">
                      <v-card>
                        <v-card-title>
                          <span class="headline">เพิ่มข้อมูล</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                          <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                          >
                            <v-row>
                              <v-col cols="12" sm="4">
                                <v-select
                                v-model="formAdd.familyStatus"
                                :items="family_status"
                                :rules="nameRules"
                                label="ความสัมพันธ์ *"
                                required
                                dense
                                outlined
                                @change="checkStatus()"
                                ></v-select>
                                </v-col>

                              <v-col cols="12" sm="4">
                                <v-select
                                v-model="formAdd.familyTitleName"
                                :items="titleNameTH"
                                :rules="nameRules"
                                label="คำนำหน้า *"
                                required
                                dense
                                outlined
                                placeholder="Select..."
                                ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="formAdd.familyFirstName"
                                    label="ชื่อ *"
                                    :counter="50"
                                    maxlength="50"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="formAdd.familyLastName"
                                    label="นามสกุล *"
                                    :counter="50"
                                    maxlength="50"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-select
                                  v-model="formAdd.familyCareer"
                                  :items="masterCareer"
                                    label="อาชีพ"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="formAdd.familyAddress"
                                    label="ที่อยู่/สถานที่ทำงาน"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                v-model="formAdd.familyTel"
                                    label="เบอร์โทรศัพท์ *"
                                    :counter="10"
                                    maxlength="10"
                                    :rules="numberRules"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>
                             <v-col cols="12" sm="4">
                                <v-checkbox v-if="dataFamily.length <= 1"
                                  v-model="formAdd.emergencyStatus"
                                  :label="`เป็นผู้ติดต่อกรณีฉุกเฉิน`"
                                  required
                                  dense
                                ></v-checkbox>
                              </v-col>
                             <v-col cols="12" sm="4">
                                <v-checkbox
                                  v-model="formAdd.familyStayWithFamStatus"
                                  :label="`อยู่ร่วมกัน`"
                                  required
                                  dense
                                ></v-checkbox>
                               </v-col>
                            </v-row>
                          </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            elevation="2"
                            x-large
                            color="dark darken-1"
                            text
                            @click="dialogAdd = false,clearData()"
                          >
                            <v-icon left> mdi-cancel</v-icon>
                            ปิด
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-large
                            color="success"
                            text
                            :disabled="!valid_add"
                            @click="addData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            เพิ่ม
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- end add -->

                    <v-alert v-if="dataFamily.length == 0"
                      border="right"
                      colored-border
                      type="error"
                      elevation="20"
                    >
                      กรุณาเพิ่มข้อมูลครอบครัว  อย่างน้อย 1 รายการ  Please enter  at least 1 item.
                    </v-alert>

                    <!-- <v-alert v-if="dataFamily.length >= 4"
                      text
                      dense
                      color="red"
                      icon="mdi-clock-fast"
                      border="left"
                    >
                      * เพิ่มข้อมูลครอบครัว ได้สูงสุด <strong>5</strong> อันดับเท่านั้น!.
                    </v-alert> -->

                    <v-card-title class="header_1">
                    ประวัติครอบครัว
                    <v-icon color="#871B12">mdi-account-circle-outline </v-icon>
                    <v-spacer></v-spacer>
                      <v-col class='text-right'>
                      <v-btn  v-if="can" color="primary" depressed @click="dialogAdd = true , validate('ADD')">
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่มข้อมูล
                      </v-btn>
                      </v-col>
                  </v-card-title>
                  จำนวน {{dataFamily.length}} รายการ
                  <v-divider color="#871B12"></v-divider>
                    <div v-for="(items, index) in dataFamily" :key="index">
                    <v-card elevation="20">
                           <v-subheader> {{items.familyStatus}}
                              <v-icon>mdi-human-male-boy</v-icon>
                            <v-col class="text-right">
                              <v-btn  v-if="can" small color="error" @click="deleteEducation(items)">
                                <v-icon small>mdi-close</v-icon>
                                  ลบข้อมูล
                              </v-btn>
                          </v-col>
                          </v-subheader>
                            <v-divider></v-divider>
                            <v-card-text>
                            <v-form
                              ref="form_update"
                              v-model="valid_update"
                              lazy-validation
                            >
                            <v-container class="py-0">
                                <v-row>
                                <v-col cols="12" sm="4">
                                <v-select
                                v-model="items.familyTitleName"
                                :items="titleNameTH"
                                label="คำนำหน้า *"
                                :readonly="!can"
                                required
                                dense
                                outlined
                                placeholder="Select..."
                                ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="items.familyFirstName"
                                    label="ชื่อ *"
                                    :rules="nameRules"
                                    :readonly="!can"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="items.familyLastName"
                                    label="นามสกุล *"
                                    :rules="nameRules"
                                    :readonly="!can"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-select
                                  v-model="items.familyCareer"
                                  :items="masterCareer"
                                    label="อาชีพ"
                                    :readonly="!can"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                  v-model="items.familyAddress"
                                    label="ที่อยู่/สถานที่ทำงาน"
                                    :readonly="!can"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>

                                <v-col cols="12" sm="4">
                                <v-text-field
                                v-model="items.familyTel"
                                    label="เบอร์โทรศัพท์ *"
                                    :counter="10"
                                    :readonly="!can"
                                    maxlength="10"
                                    :rules="numberRules"
                                    required
                                    dense
                                    outlined
                                />
                                </v-col>
                                  <v-col class='text-right'>
                                    <v-checkbox
                                      v-model="items.emergencyStatus"
                                      :label="`เป็นผู้ติดต่อกรณีฉุกเฉิน`"
                                      false-value="False"
                                      :readonly="!can"
                                      true-value="True"
                                    ></v-checkbox>
                                    </v-col>
                                  <v-col class='text-right'>
                                    <v-checkbox
                                      v-model="items.familyStayWithFamStatus"
                                      :label="`อยู่ร่วมกัน`"
                                      :readonly="!can"
                                      false-value="False"
                                      true-value="True"
                                    ></v-checkbox>
                                    </v-col>
                            </v-row>
                            <v-col cols='12' class='text-right' v-if="can">
                                  <v-btn small
                                    color='success'
                                    class="mr-0"
                                    :disabled="!valid_update"
                                    @click="editData(items)"
                                  >
                                    แก้ไขข้อมูล
                                  </v-btn>
                                </v-col>
                              </v-container>
                            </v-form>
                          </v-card-text>
                          </v-card>
                          <br>
                          <br>
                          </div>
                          <br>
                </v-list>
                <v-row no-gutters>
              <v-footer fixed height="60px" color="#262A34">
                <v-col class='text-right'>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushBack"
                >
                <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                  ย้อนกลับ
                </v-btn>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushNext"
                >
                  หน้าถัดไป
                  <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                </v-btn>
              </v-col>
              </v-footer>
            </v-row>
            </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import titleNameTH from '../../../assets/master/titleName/titleNameTH.json'
import familyStatusTH from '../../../assets/master/FamilyStatus/familyStatusTH.json'
import careerTH from '../../../assets/master/Career/careerTH.json'

export default {
  components: {
    'left-emp-menu': EmpMenu
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      rollHR: false,
      path: '/employee_family/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      checkbox: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      session: this.$session.getAll(),
      dialogAdd: false,
      // family_status: ['พ่อ', 'แม่', 'พี่', 'น้อง', 'ภรรยา', 'สามี', 'บุตรคนที่ 1 ', 'บุตรคนที่ 2', 'ลุง', 'ป้า', 'น้า', 'อา', 'ปู่', 'ย่า', 'ตา', 'ยาย'],

      formAdd: {
        empCode: '',
        familyStatus: '',
        familyTitleName: '',
        familyFirstName: '',
        familyLastName: '',
        familyCareer: '',
        familyAddress: '',
        familyTel: '',
        emergencyStatus: ''
      },
      dataFamily: [],
      numberRules: [
        (v) => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      nameRules: [
        (v) => !!v || 'Input is required'
      ],

      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      titleNameTH: titleNameTH,
      masterCareer: careerTH,
      family_status: familyStatusTH,
      familyID: '',
      dataEmp: '',
      can: true
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    checkStatus () {
      let rs = this.dataFamily
      if (rs.length > 0) {
        for (var i = 0; i < rs.length; i++) {
          var d = rs[i]
          if (this.formAdd.familyStatus === d.familyStatus) {
            this.formAdd.familyStatus = ''
            this.$swal('โปรดตรวจสอบข้อมูล', 'คุณมีข้อมูล ' + d.familyStatus + ' แล้ว', 'error')
            this.formAdd.familyStatus = this.clearData()
            this.formAdd.familyStatus = this.validate()
          }
        }
      }
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.getDataByFamily()
      }
    },
    async getDataByFamily () {
      console.log(this.dataEmp)
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            this.dataFamily = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.dataFamily = []
          console.log('error function getDataById : ', error)
        })
    },
    async editData (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.familyID
          let databylogin = localStorage.getItem('data')
          let ds = {
            familyStatus: dt.familyStatus,
            familyTitleName: dt.familyTitleName,
            familyFirstName: dt.familyFirstName,
            familyLastName: dt.familyLastName,
            familyCareer: dt.familyCareer,
            familyAddress: dt.familyAddress,
            familyTel: dt.familyTel,
            emergencyStatus: dt.emergencyStatus,
            familyStayWithFamStatus: dt.familyStayWithFamStatus,
            LAST_USER: databylogin.userName
          }
          console.log(ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.getDataByFamily()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async addData () {
      let databylogin = localStorage.getItem('data')
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = databylogin.userName
      this.formAdd.LAST_USER = databylogin.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = this.dataEmp.empCode

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          delete this.formAdd['familyID']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                this.getDataByFamily()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async deleteEducation (d) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          let databylogin = localStorage.getItem('data')
          let ds = {
            LAST_USER: databylogin.userName
          }

          await axios
            .post(
            // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + d.familyID,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
            // Debug response
              this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
              this.getDataByFamily()
              this.dataFamily = []
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function deleteDataGlobal : ', error)
            })
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    pushNext () {
      this.$router.push(
        '/HRM/Employee/EmployeeEducation')
    },
    pushBack () {
      this.$router.push(
        '/HRM/Employee/EmployeeAddress')
    }
  }
}
</script>
<style scope>
.scroll {
   overflow-y: scroll
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

color: #871B12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeFamily.vue